import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { cx, css } from '@lastbrand/web-ui-styled-system/css'

import { dsOptions } from '@src/quince-components/src/molecules/RichText/richText.helpers'

import { mergeLegacyResponsiveStyles } from './classname-to-ds-style'

import type { RichTextDSProps } from './rich-text-ds.types'

/**
 * Renders a Contentful rich-text document. Layout-neutral by design — the
 * caller decides flow (legacy `.wrapper` SCSS is also layout-neutral, only
 * carrying `a { color: inherit }`).
 *
 * `baseStyle` + `css` flow into a single `css(...)` call so caller-supplied
 * `css` always wins on conflicting properties, regardless of Panda stylesheet
 * order. `style` carries dynamic numeric inline CSS custom properties that the
 * caller's `className` is responsible for consuming.
 */
export function RichTextDS({ content, baseStyle, css: cssProp, className, style }: RichTextDSProps) {
  const mergedStyle = baseStyle && cssProp ? mergeLegacyResponsiveStyles(baseStyle, cssProp) : (cssProp ?? baseStyle)
  const wrapperClass = cx(mergedStyle ? css(mergedStyle) : undefined, className)

  return (
    <div data-testid="rich-text-ds" className={wrapperClass} style={style}>
      <div data-testid="rich-text-ds-content" className={css({ '& a': { color: 'inherit' } })}>
        {documentToReactComponents(content, dsOptions)}
      </div>
    </div>
  )
}
